// extracted by mini-css-extract-plugin
export default {"PersonList":"EditablePersonList_PersonList__v1WGx","PersonListItem":"EditablePersonList_PersonListItem__8hQ0G","Indicator":"EditablePersonList_Indicator__HAgwc"};